export class User {
    admin:any;
    sucess:string;
    token?:string;
}